import React from "react";
import { motion } from "framer-motion";
import SectionHeading from "../SectionHeading";

const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

/**
 * The "industries we support" chip grid on a service detail page.
 *
 * `icons` is passed in rather than imported: each page's document names its own
 * sectors, and the page-local map keeps sector-specific glyphs out of the icon
 * registry the rest of the site shares. All are decorative UI glyphs, never
 * certification marks.
 */
const ServiceIndustriesSection = ({
  id,
  title,
  intro,
  industries,
  icons,
  tone = "muted",
}) => (
  <section
    className={`${tone === "light" ? "bg-white" : "bg-gray-50"} py-14 lg:py-20`}
    aria-labelledby={id}
  >
    <div className="brand-col">
      <SectionHeading
        id={id}
        title={title}
        subtitle={intro}
        /* a lead-in sentence, not a sub-heading — these documents give this
           section none */
        subtitleAs="p"
        subtitleClassName="mx-auto max-w-2xl text-sm md:text-base leading-relaxed text-gray-600"
      />
      <motion.ul
        className="grid list-none grid-cols-1 gap-4 p-0 sm:grid-cols-2 lg:grid-cols-4"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
        variants={{ visible: { transition: { staggerChildren: 0.06 } } }}
      >
        {industries.map((industry) => {
          const Icon = icons[industry.icon];
          return (
            <motion.li
              key={industry.name}
              variants={itemVariants}
              className="brand-card brand-card-row gap-4 p-5"
            >
              {Icon && (
                <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-[var(--brand-primary)] text-white shadow-md">
                  <Icon aria-hidden="true" className="h-5 w-5" />
                </span>
              )}
              <span className="text-sm md:text-base font-semibold text-gray-900">
                {industry.name}
              </span>
            </motion.li>
          );
        })}
      </motion.ul>
    </div>
  </section>
);

export default ServiceIndustriesSection;
